import Model from '@/models/create'

export default {
    namespaced:true,
    state:{
        list:[],
        detail: {},
        carNoList: [],
        parkList: [],
        total:0
    },
    getters:{
        getTable(state){
            return state.list
        },
        getDetail(state){
            return state.detail
        },
        getTotal(state){
            return state.total
        },
        getCarNoList(state) {
            let array = state.carNoList;
            array = array.map(item=>{
                return {
                    lable:item,
                    value:item
                };
            })
            return array
        },
        getParkList(state) {
            return state.parkList
        }
    },
    mutations:{
        setTable(state,{data}){
            if(data.success){
                state.list=data.list;
                state.total=data.pagination.total;
            }
        },
        setDetail(state,payload){
            if(typeof(payload)==='object'){
                state.detail=payload;
            }else{
                let detail=state.list.filter(item=>item.allotId===payload)[0];
                state.detail=detail;
                // for(let key in state.detail){
                //     state.detail[key]=detail[key]
                // }
            }
        },
        setCarNoList(state,{data}) {
            if(data.success) {
                state.carNoList = data.list.filter((item,index)=>index<300);
            }
        },
        setParkList(state, data) {
            state.parkList = data;
        },
        emptyDetail(state){
            for(let key in state.detail){
                state.detail[key]=''
            }
        }
    },
    actions:{
        async setTableAction({commit},payload){
            commit('setTable',await Model.getTable(payload))
        },
        async setCarNoListAction({commit},payload) {
            commit('setCarNoList',await Model.getCarNoList(payload))
        },
        async setParkListAction({commit},payload) {
            const { data } = await Model.getParkList(payload);
            return new Promise((resolve, reject) => {
                if(data.success) {
                    commit('setParkList', data.list)
                    resolve(data)
                }else {
                    reject(data)
                }
            })
        },
        setDetailAction({commit},payload){
            commit('setDetail',payload)
        },
        emptyDetailAction({commit}){
            commit('emptyDetail')
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/create.js